import { createFileRoute } from "@tanstack/react-router";
import { VisualizationHome } from "@/pages/3d/visualization/VisualizationHome";

export const Route = createFileRoute("/demo/3d/visualization/")({
  component: VisualizationHome,
});
